import { useState } from "react";
import AdminTopLista from "./utils/AdminTopLista";
import AdminLevels from "./utils/AdminLevels";
import { useEffect } from "react";

export default function Admin(props) {

  const [users, setUsers] = useState([]);
  const [levels, setLevels] = useState([]);

  useEffect(() => {
    fetch(process.env.REACT_APP_API + "/admin/allusers", {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("access_token")}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setUsers(data.data);
        }
      });

    fetch(process.env.REACT_APP_API + "/admin/alllevels", {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("access_token")}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setLevels(data.data);
        }
      });
  }, []);

  return (
    <div className="m-5" style={{ color: "white" }}>
      <h2>Scoreboard:</h2>
      <AdminTopLista users={users} />
      <h2 className="mt-5">Kaikki kilpailun vaiheet:</h2>
      <AdminLevels levels={levels} users={users} />
    </div>
  );
}